import { useState, useEffect, memo, useMemo, useCallback } from 'react';
import PublishNoticeContentAccessInfo from './internal/PublishNoticeContentAccessInfo';
import RegistrationEmailSendingAcknowledgement, { EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD } from './alerts/RegistrationEmailSendingAcknowledgement';
import useFetchContactsRegistrationCount from '../hooks/useFetchContactsRegistrationCount';
import { AccessControlTypes } from '../constants/AccessControlTypes';
import { allFinishedWithSuccess } from 'settings-ui-lib/utils/requestStatusChecks';
import { getContentAccessSettingsInfoFromContent } from '../utils/contentAccessSettings';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentAccessSettingsPublishNotice = ({
  contentType,
  contentAccessProperties,
  isEmailSendingAcknowledgementChecked,
  onEmailSendingAcknowledgementChange,
  onUnregisteredContactsCountFetchSuccess
}) => {
  const selectedContentSettingsInfo = useMemo(() => getContentAccessSettingsInfoFromContent(contentAccessProperties), [contentAccessProperties]);
  const {
    contentCountByAccessControlType
  } = selectedContentSettingsInfo;
  const [agsForAccessGroupMembership, setAGsForAccessGroupMembership] = useState([]);
  const accessGroupMembershipILSIds = useMemo(() => agsForAccessGroupMembership.map(group => group.ilsListId), [agsForAccessGroupMembership]);
  const {
    count: unregisteredContacts,
    contactsRegistrationCountRequestStatus: unregisteredContactsRequestStatus
  } = useFetchContactsRegistrationCount({
    ilsListIds: accessGroupMembershipILSIds,
    isRegistered: false,
    shouldFetchData: accessGroupMembershipILSIds.length > 0
  });
  useEffect(() => {
    if (allFinishedWithSuccess(unregisteredContactsRequestStatus)) {
      onUnregisteredContactsCountFetchSuccess(unregisteredContacts);
    }
  }, [onUnregisteredContactsCountFetchSuccess, unregisteredContacts, unregisteredContactsRequestStatus]);
  const shouldShowEmailSendingAcknowledgement = !!contentCountByAccessControlType[AccessControlTypes.ACCESS_GROUP_MEMBERSHIP] && allFinishedWithSuccess(unregisteredContactsRequestStatus) && unregisteredContacts >= EMAIL_SENDING_ACKNOWLEDGEMENT_THRESHOLD;
  const handleAGsForAccessGroupMembershipFetchSuccess = useCallback(accessGroups => {
    setAGsForAccessGroupMembership(accessGroups);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PublishNoticeContentAccessInfo, {
      contentType: contentType,
      selectedContentSettingsInfo: selectedContentSettingsInfo,
      onAGsForAccessGroupMembershipFetchSuccess: handleAGsForAccessGroupMembershipFetchSuccess
    }), shouldShowEmailSendingAcknowledgement && /*#__PURE__*/_jsx(RegistrationEmailSendingAcknowledgement, {
      marginBlockEnd: "400",
      contentType: contentType,
      contentCount: contentCountByAccessControlType[AccessControlTypes.ACCESS_GROUP_MEMBERSHIP],
      isEmailSendingAcknowledgementChecked: isEmailSendingAcknowledgementChecked,
      onEmailSendingAcknowledgementChange: onEmailSendingAcknowledgementChange,
      unregisteredContacts: unregisteredContacts
    })]
  });
};
export default /*#__PURE__*/memo(ContentAccessSettingsPublishNotice);